import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/authSlice.ts";
import NavBarItem from "./NavBarItem.tsx";
import { RootState } from "../../store/index.ts";
import { Routes } from "./Routes.tsx";
import DropdownComponent from "./DropdownComponent.tsx";
import DirectBossStatusProvider from "./DirectBossStatusProvider.tsx";
import { roleMatchesValidRoles } from "./navRoleAccess.ts";

function NavBar() {
  const { isAdmin, user, partner } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [active, setActive] = React.useState<string>("");
  const { isDirectBoss } = useSelector((s: RootState) => s.directBoss);
  const isVacationsResponsible = partner?.isVacationsResponsible === true;

  React.useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    // Para rutas de sucursal, usar la segunda parte; para otras, usar la primera
    if (pathParts[0] === "sucursal" && pathParts.length > 1) {
      setActive(pathParts[1]);
    } else {
      setActive(pathParts[0] || "");
    }
  }, [location.pathname]);


  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark bg-dark"
      style={{
        margin: '12px 12px 0 12px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.18)',
        position: 'sticky',
        top: 12,
        zIndex: 1000,
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        paddingTop: 6,
        paddingBottom: 6,
        minHeight: 'unset',
      }}
    >
      <div className="container-fluid">
        <DirectBossStatusProvider />
        <a
          className="navbar-brand"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <div className="brand" style={{ padding: '4px 8px' }}>
            <div className="w-50px" style={{ width: 44 }}>
              <img
                src="../../../../assets/img/logo/logo_chili_rojo.png"
                alt=""
                className="w-100"
              />
            </div>
          </div>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav flex-wrap">
            {Routes.map((route) => {
              const userRole = user.rol;
              const canAccessRoute = () => {
                if (roleMatchesValidRoles(userRole, route.validRoles)) {
                  return true;
                }
                
                // Si es trabajador
                if (userRole === "Trabajador") {
                  // Si es jefe directo, puede acceder a rutas específicas de gestión
                  if (isDirectBoss) {
                    const directBossRoutes = ["incapacidades", "permisos", "vacaciones", "incidencias"];
                    const isDirectBossRoute = directBossRoutes.some(routeName => 
                      route.to.includes(routeName) || route.activeKey.includes(routeName)
                    );
                    // Solo mostrar rutas que sean específicamente para Trabajador, no para otros roles
                    const isOnlyForTrabajador = route.validRoles.length === 1 && route.validRoles.includes("Trabajador");
                    const canAccess = (isDirectBossRoute && isOnlyForTrabajador) || (route.validRoles.includes("Trabajador") && !route.to.includes("/sucursal"));
                    return canAccess;
                  }
                  
                  if (isVacationsResponsible && route.to.includes("vacaciones")) {
                    return true;
                  }
                  const canAccess = route.validRoles.includes("Trabajador");
                  return canAccess;
                }
                
                return false;
              };

              if (canAccessRoute()) {
                return (
                  <NavBarItem
                    key={route.name}
                    active={active}
                    name={route.name}
                    to={route.to}
                    activeKey={route.activeKey}
                    icon={route.icon}
                    childrenRoutes={route.children}
                    isNew={route.isNew}
                    disabled={route.disabled}
                  />
                );
              }
            })}
            <li className="nav-item d-block d-md-none">
              <DropdownComponent />
            </li>
          </div>
        </div>
      </div>
      <div
        className="collapse navbar-collapse"
        id="navbarTogglerDemo03"
        style={{ paddingRight: "2%" }}
      >
        <ul className="navbar-nav mr-auto mt-2 mt-lg-0 mr-2">
          <li className="nav-item">
            <DropdownComponent />
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
